import React from "react";
import { Navigate } from "react-router-dom";
import { UserContext } from "../../../features/admin/providers/UserProvider";
import { getFirstAvailableRoute } from "../../utils/routeUtils";

/**
 * Component that redirects users to the first page they have access to
 * Used as the default route ("/") to handle permission-based routing
 */
export const HomeRedirect: React.FC = () => {
  const { user } = React.useContext(UserContext);

  if (!user) {
    // If user is not loaded yet, show nothing or a loading state
    return null;
  }

  const redirectPath = getFirstAvailableRoute(user.attributes);

  return <Navigate to={redirectPath} replace />;
};
